export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/car/index/resources/computed.js